import * as React from "react";
import { ToolButton } from "ui/Scripts/source/components/framework/Button/ToolButton";
import { Translations } from "ui/Scripts/source/models/translations";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import { Box, TextField, Typography } from "@mui/material";

// LongText
// ***********************************************************************************************************************
export interface ILongTextProp {
  autoFocus?: boolean;
  classes?: string;
  disabled?: boolean;
  expandable?: boolean;
  maxLength?: number;
  name?: string;
  required?: boolean;
  title?: string;
  titleClasses?: string;
  value: string;
  valueClasses?: string;
  marginTop?: string | number;
  onChange(e: any);
}

export interface ILongTextState {
  expanded: boolean;
}

export class LongText extends React.Component<ILongTextProp, ILongTextState> {
    static defaultProps = {
        marginTop: "1rem",
    };

    private orgRect: DOMRect;
    private mainDiv: HTMLDivElement;
    private contentDiv: HTMLDivElement;

    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };
    }

    handleExpand = (expand: boolean) => {
        if (expand) {
            this.orgRect = this.mainDiv.getBoundingClientRect();
            this.mainDiv.style.height = this.orgRect.height.toString(10) + "px";
            this.contentDiv.style.position = "fixed";
            this.contentDiv.style.top = this.orgRect.top.toString(10) + "px";
            this.contentDiv.style.left = this.orgRect.left.toString(10) + "px";
            this.contentDiv.style.width = this.orgRect.width.toString(10) + "px";
            this.contentDiv.style.height = this.orgRect.height.toString(10) + "px";
            window.setTimeout(() => {
                this.contentDiv.style.top = "0";
                this.contentDiv.style.left = "0";
                this.contentDiv.style.width = "100%";
                this.contentDiv.style.height = "100%";
                this.contentDiv.style.padding = "15px";
                this.contentDiv.style.backgroundColor = "#ced4da";
            }, 50);
            this.setState({ expanded: expand });
        } else {
            window.setTimeout(() => {
                this.contentDiv.style.top = this.orgRect.top.toString(10) + "px";
                this.contentDiv.style.left = this.orgRect.left.toString(10) + "px";
                this.contentDiv.style.width = this.orgRect.width.toString(10) + "px";
                this.contentDiv.style.height = this.orgRect.height.toString(10) + "px";
                this.contentDiv.style.padding = "0";
                this.contentDiv.style.backgroundColor = null;
                window.setTimeout(() => {
                    this.mainDiv.style.height = null;
                    this.contentDiv.style.position = null;
                    this.contentDiv.style.top = null;
                    this.contentDiv.style.left = null;
                    this.contentDiv.style.width = null;
                    this.contentDiv.style.height = null;
                    this.contentDiv.style.padding = null;
                    this.setState({ expanded: expand });
                }, 200);
            }, 50);
        }
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Box
                className={
                    "longText small-control-labels" +
                        (props.classes ? " " + props.classes : "") +
                        (props.expandable ? " expandable" : "") +
                        (state.expanded ? " expanded" : "") +
                        (props.disabled ? " disabled" : "")
                }
                ref={(div: HTMLDivElement) => {
                    this.mainDiv = div;
                }}
                sx={{ marginTop: props.marginTop, marginBottom: "0 !important" }}
            >
                <Box
                    className="contents"
                    ref={(div: HTMLDivElement) => {
                        this.contentDiv = div;
                    }}
                >
                    {!!props.title && (
                        <Box
                            component="label"
                            sx={{
                                display: "flex",
                                flexGrow: 2,
                                justifyContent: "space-between",
                            }}
                            onClick={(e) => e.preventDefault() }
                        >
                            <Typography
                                variant="caption"
                                sx={{ color: "text.secondary" }}
                                className={
                                    "text" +
                                        (props.titleClasses ? " " + props.titleClasses : "") +
                                        (props.required ? " redStartAfter" : "")
                                }
                            >
                                {props.title}
                            </Typography>
                            {!!props.expandable && (
                                <ToolButton
                                    variant="icon"
                                    icon={state.expanded ? <FullscreenExitIcon /> : <FullscreenIcon />}
                                    tooltip={state.expanded ? Translations.Collapse : Translations.Expand}
                                    onClick={() => this.handleExpand(!state.expanded)}
                                />
                            )}
                        </Box>
                    )}
                    <TextField
                        name={props.name}
                        title={props.title}
                        inputProps={{ maxLength: props.maxLength }}
                        multiline
                        minRows={5}
                        value={props.value}
                        onChange={props.onChange}
                        disabled={props.disabled}
                        size="small"
                        fullWidth
                        sx={{
                            "height": state.expanded ? "calc(100% - 49px)" : undefined,
                            ".MuiInputBase-root": {
                                "height": state.expanded ? "100%" : undefined,
                                "textarea": {
                                    "height": state.expanded ? "100% !important" : undefined,
                                },
                            },
                        }}
                    />
                </Box>
            </Box>
        );
    }
}
